import React from 'react';

function StationComponent() {
    return <div>StationComponent</div>;
}

export default StationComponent;
